import styled from 'styled-components';
import Dropdown from '../../drop-down/Dropdown';
import Typography from '../../typography/Typography';
export const CustomDropDown = styled(Dropdown) `
  margin: 0 1.6rem 1.6rem;

  box-shadow: ${({ theme }) => theme.shadows.sm};

  ${({ theme }) => theme.media.tabletL `
    margin: 0 0 2rem;
  `}
`;
export const InfoWrapper = styled.div `
  margin-top: 1.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};
`;
export const Row = styled.div `
  padding: 1.6rem;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  }
  &:first-child {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.high};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.high};
  }
  &:last-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.high};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.high};
  }
  ${({ theme }) => theme.media.tabletL `
    display: flex;

    align-items: center;

    padding: 3rem 2.2rem;
  `}
`;
export const Title = styled(Typography) `
  ${({ theme }) => theme.media.tabletL `
    margin-right: 3.6rem;
    width: 14rem;
  `}
`;
export const Desc = styled(Typography) `
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.text.default};
  line-break: anywhere;
  ${({ theme }) => theme.media.tabletL `
    font-size:1.6rem;
    line-height: 2.4rem;
  `}
`;
export const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.media.tabletL `
    flex: 1;
  `}
`;
export const ButtonWrapper = styled.div `
  width: fit-content;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
`;
//# sourceMappingURL=styles.js.map